export type AuthEvent = "session-expired" | "verification-required";

let authEventHandler: ((event: AuthEvent) => void) | null = null;

export const registerAuthEventHandler = (
  handler: (event: AuthEvent) => void
) => {
  authEventHandler = handler;
};

export const emitAuthEvent = (event: AuthEvent) => {
  authEventHandler?.(event);
};
